import { useFormik } from 'formik';
import React, { Dispatch, SetStateAction, useState } from 'react';
import VoxelDialog from '../../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogActionSubmit from '../../../../components/voxel/Dialogs/VoxelDialogActionSubmit';
import VoxelDialogActions from '../../../../components/voxel/Dialogs/VoxelDialogActions';
import VoxelDialogContent from '../../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelTextarea from '../../../../components/voxel/Forms/VoxelTextArea';
import VoxelText from '../../../../components/voxel/Text/VoxelText';
import { ProjectGq } from '../../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';

export interface UploadFromSpreadSheetDialogProps {
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
  project: ProjectGq;
  onSuccess: () => Promise<any>;
}

interface FormState {
  projectId: number;
  pasteArea: string;
}

const UploadFromSpreadSheetDialog: React.FC<UploadFromSpreadSheetDialogProps> = ({
  openDialog,
  setOpenDialog,
  project,
  onSuccess,
}) => {

  const [loading, setLoading] = useState(false);
  const uploadSpreadSheetMutation = projectsApiService.mutations.tags.useImportTagStructure();
  const formBag = useFormik<FormState>({
    initialValues: {
      projectId: project.id,
      pasteArea: '',
    },
    onSubmit: (values, actions) => {
      setLoading(true);
      uploadSpreadSheetMutation({
        projectId: project.id,
        pasteArea: values.pasteArea,
      })
        .then(() => actions.resetForm())
        .then(() => setLoading(false))
        .finally(() => onSuccess());
    },
  });

  return (
    <VoxelDialog
      minWClass={'min-w-[800px]'}
      title={'Upload keyword tag structure from spreadsheet (Beta)'}
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      closeOnBackdrop={false}
    >
      <VoxelDialogContent className='flex flex-col gap-2'>
        <VoxelText variant="bread-normal" paddingBot>
          Copy spreadsheet with columns in the following order: "Tag group", "Tag", "Keyword" and paste its contents inside the paste area. Tags and keywords are optional.
        </VoxelText>
        <div className="w-full flex flex-col gap-2">
          <VoxelTextarea
            label='Paste area'
            minRows={18}
            maxLength={50000}
            resizeOff
            placeholder={'tag group A \t tag A \t keyword 1\ntag group A \t tag B \t keyword 2 '}
            value={formBag.values.pasteArea}
            onChange={(event) => formBag.setFieldValue('pasteArea', event.target.value)}
          />
        </div>
      </VoxelDialogContent>
      <VoxelDialogActions>
        <VoxelDialogActionSubmit
          title="Submit"
          submitting={loading}
          onClick={formBag.submitForm}
          disabled={
            !formBag.values.pasteArea ||
            !formBag.dirty ||
            !formBag.isValid
          }
        />
      </VoxelDialogActions>
    </VoxelDialog>
  );
};

export default UploadFromSpreadSheetDialog;
